import React, { memo } from "react";

export const ValidationMessage = memo(
    ({ condition, text }: { condition: boolean; text: string }) =>
        condition ? (
            <div
                style={{
                    width: "100%",
                    marginTop: "0.25rem",
                    fontSize: "80%",
                    color: "#f46a6a",
                }}
            >
                {text}
            </div>
        ) : null
);
